module.exports = __webpack_public_path__ + "img/hotel-florida.aece3435.jpg";